import ICoordinate from './ICoordinate';

export default class MapService {
    private static baseLocation: ICoordinate = {
        longitude: 12.00692,
        latitude: 57.731942
    };

    private static canUseGeoLocation(): boolean {
        // Geolocation can only be used on localhost or over https
        return (
            navigator.geolocation &&
            (location.protocol === 'https:' || location.host.indexOf('localhost') >= 0)
        );
    }

    static getCurrentLocationCoordinate(): Promise<ICoordinate> {
        return new Promise<any>((resolve, reject) => {
            if (this.canUseGeoLocation()) {
                navigator.geolocation.getCurrentPosition((position: Position) => {
                    let center: ICoordinate = {
                        longitude: position.coords.longitude,
                        latitude: position.coords.latitude
                    };

                    resolve(center);
                });
            } else {
                resolve(this.baseLocation);
            }
        });
    }

    static getAddress(
        address: string,
        postalNumber?: string,
        city?: string
    ): Promise<google.maps.GeocoderResult> {
        return new Promise((resolve, reject) => {
            let addressList = [address];

            if (postalNumber) {
                addressList.push(postalNumber);
            }

            if (city) {
                addressList.push(city);
            }

            let geocoder = new google.maps.Geocoder();
            geocoder.geocode(
                { address: addressList.join(' ') },
                (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                    if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                        resolve(results[0]);
                    } else {
                        resolve(null);
                    }
                }
            );
        });
    }

    static getAddresFromPosition(longitude: number, latitude: number) {
        return new Promise((resolve, reject) => {
            let position = { lng: longitude, lat: latitude };
            let geocoder = new google.maps.Geocoder();

            geocoder.geocode(
                { location: position },
                (results: google.maps.GeocoderResult[], status: google.maps.GeocoderStatus) => {
                    if (status === google.maps.GeocoderStatus.OK && results.length > 0) {
                        resolve(results[0]);
                    } else {
                        resolve(null);
                    }
                }
            );
        });
    }
}
